import React, { Component } from 'react';
import {
  DatePickerSkeleton,
  TableHeader,
  DataTableSkeleton,
  TableHead,
  TextInput,
  Button,
  DataTable,
  Form,
  TableToolbar,
  FormGroup,
  FormLabel,
  Pagination,
  Tabs,
  Tab,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Loading,
} from 'carbon-components-react';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import '../../scss/custom.scss';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import moment, { invalid } from 'moment';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  DateFormat,
} from '../../helpers/Constants';
import { tasks, me } from '../../helpers/api/api';
import { TaskCategory } from '../../helpers/Constants.js';
import { CheckmarkOutline16, ChevronRight16 } from '@carbon/icons-react';
import { ComboBox } from '../../helpers/ComboBox';
import { Link, Route } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import DateTimePicker from '../../helpers/DateTimePicker';

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.

const searchProp = {
  category: null,
  module: null,
  content: null,
  status: null,
  dueDate: null,
  dueDateFrom: null,
};
export default class AllTheTasks extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();

    this.state = {
      isLoading: true,
      isLoadingDate: false,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      itemList: [],
      xStatus: ['Pending', 'Expired'],
      spinner: false,
      stateDivDownload: false,

      searchModel: {
        ...searchProp,
      },
      taskModel: {
        category: undefined,
        module: undefined,
        content: undefined,
        status: undefined,
        dueDate: undefined,
        assignedDate: undefined,
        reference: undefined,
      },
    };
    this.taskDone = this.taskDone.bind(this);
    this.taskCompleted = this.taskCompleted.bind(this);
    this.getTaskList = this.getTaskList.bind(this);
    this.renderSearchform = this.renderSearchform.bind(this);
    // this.showDivDownload = this.showDivDownload.bind(this);
    this.toggleSearchForm = this.toggleSearchForm.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
    this.renderDataTable = this.renderDataTable.bind(this);
  }
  //
  componentDidMount() {
    this.getTaskList();
  }
  selectTab(tabIndex) {
    if (tabIndex == 0) {
      this.setState(
        {
          searchModel: {
            category: null,
          },
        },
        () => this.getTaskList()
      );
    }
    if (tabIndex == 1) {
      this.setState(
        {
          searchModel: {
            category: TaskCategory.CATEGORY_APPROVAL,
          },
        },
        () => this.getTaskList()
      );
    }
    if (tabIndex == 2) {
      this.setState(
        {
          searchModel: {
            category: TaskCategory.CATEGORY_COMPILATION,
          },
        },
        () => this.getTaskList()
      );
    }
  }

  //METODI
  taskDone(id) {
    this.setState({
      spinner: true,
    });
    tasks
      .put(id)
      .then((response) => {
        this.getTaskList();
        showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.TASK, apioperation.POST));
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.TASK, apioperation.POST));
      })
      .finally(() => {
        this.setState({
          spinner: false,
        });
      });
    //this.getTaskColor(row)
  }
  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  toggleSearchForm(e) {
    e.preventDefault();
    this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
  }

  handleChangeSearch = (el) => {
    let inputName = el.target.name;

    let inputValue = el.target.value;

    this.updateState(inputName, inputValue, 'searchModel');
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    let inputValue = selectedItem ? selectedItem : null;

    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    //statusCopy['selectedItemCombo'][inputName] = selectedItem;
    this.setState(statusCopy);
  };

  handleClickSearch = (e) => {
    e.preventDefault();
    this.getTaskList({ page: 1 });
  };

  handleClickCancelSearch = (e) => {
    e.preventDefault();
    this.toggleSearchForm(e);
    this.setState(
      {
        searchModel: {
          ...searchProp,
        },
      },
      () => {
        this.getTaskList({ page: 1 });
      }
    );
  };
  //Call api
  getTaskList(param) {
    if (this.validator.allValid()) {
      this.setState({
        isLoading: true,
      });
      const data = {
        params: {
          page: param && param.page ? param.page : this.state.currentPage,
          pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
          ...this.state.searchModel,
        },
      };

      me.getWithParam('tasks', data)
        .then((response) => {
          this.setState({
            ...response.data,
          });
        })
        .catch((error) => {
          // showNotification.error(getError(error, "Task List", "ERROR"));
        })
        .finally(() => {
          this.setState({
            isLoading: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,' Date required fields are missing  ');

      this.forceUpdate();
    }
  }

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };
  divDownload() {
    return (
      <div className="notification-box-action">
        <div className="notification-items">
          <ul>
            <div className="bx--row notification-item  notification">
              <div className="bx--col notification-action">
                <span className="">Download xls</span>
              </div>
            </div>
            <div className="bx--row notification-item  notification">
              <div className="bx--col notification-action">
                <span className="">Print Pending task</span>
              </div>
            </div>
          </ul>
        </div>
      </div>
    );
  }
  handleChangeDPInput = (value) => {
    if (value == null || value.target == null || value.target.value == null) {
      this.updateState('dueDate', null, 'searchModel');
      return;
    }
    try {
      var date = value.target.value;
      var s = date.split('/');
      if (s.length < 3) return;

      var dd = s[0];
      var mm = s[1];
      var yy = s[2];
      if (dd.length < 2 || mm.length < 2 || yy.length < 4) return;

      date = `${yy}-${mm}-${dd}`;

      this.updateState('dueDate', date, 'searchModel');
      return;
    } catch {
      return null;
    }
  };
  handleChangeDP = (value) => {
    if (value == null || value[0] == null) {
      this.updateState('dueDate', null, 'searchModel');
      return;
    }

    var date = value[0];
    var date2 = value[0];
    if (typeof date === 'object') {
      date2 = moment(date2).format('YYYY-MM-DD');
    }

    this.updateState('dueDate', date2, 'searchModel');
    return;
  };
  handleChangeDPInput2 = (value) => {
    if (value == null || value.target == null || value.target.value == null) {
      this.updateState('dueDateFrom', null, 'searchModel');
      return;
    }
    try {
      var date = value.target.value;
      var s = date.split('/');
      if (s.length < 3) return;

      var dd = s[0];
      var mm = s[1];
      var yy = s[2];
      if (dd.length < 2 || mm.length < 2 || yy.length < 4) return;

      date = `${yy}-${mm}-${dd}`;

      this.updateState('dueDateFrom', date, 'searchModel');
      return;
    } catch {
      return null;
    }
  };
  handleChangeDP2 = (value) => {
    if (value == null || value[0] == null) {
      this.updateState('dueDateFrom', null, 'searchModel');
      return;
    }

    var date = value[0];
    var date2 = value[0];
    if (typeof date === 'object') {
      date2 = moment(date2).format('YYYY-MM-DD');
    }

    this.updateState('dueDateFrom', date2, 'searchModel');
    return;
  };
  handleChangePaging = (event) => {
    this.getTaskList(event);
  };

  renderSearchform() {
    const selectedItemCombo = {
      status: (this.state.status || []).find((el) => el == this.state.taskModel.status),
    };
    const filterItems = {
      status: null,
    };

    if (this.state.searchModel != null) {
      var diffduedate =
        (!this.state.searchModel.dueDate && !this.state.searchModel.dueDateFrom) ||
        moment(this.state.searchModel.dueDate).isSameOrAfter(
          moment(this.state.searchModel.dueDateFrom),
          'day'
        );
    } else {
      var diffduedate = true;
    }

    const validations = {
      //immediateActions: this.validator.message('Immediate Actions', this.state.hocCardModel.immediateActions, 'required'),
      dueDate: this.validator.message('Due Date', diffduedate, 'accepted'),
    };
    return (
      this.state.isOpenSearchForm && (
        <div>
          <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel> Module </FormLabel>
              <TextInput
                id="inputsearch"
                name="module"
                value={this.state.searchModel.module}
                onChange={this.handleChangeSearch}
                placeholder="Input Module"
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel> Content </FormLabel>
              <TextInput
                id="inputsearch"
                name="content"
                value={this.state.searchModel.content}
                onChange={this.handleChangeSearch}
                placeholder="Input Content"
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class">Status</FormLabel>

              <ComboBox
                id="idSearchStatus"
                placeholder="All"
                name="status"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item : '')}
                initialSelectedItem={filterItems.status}
                items={this.state.xStatus}
                //        // items={this.state.search.search}
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class">Due Date From</FormLabel>
              {this.state.isLoadingDate ? (
                <DatePickerSkeleton />
              ) : (
                /* <DatePicker
                                id="date-picker-assignedDate"
                                datePickerType='single'
                                dateFormat="d/m/Y"
                                onChange={this.handleChangeDP2}
                                value={switchDateFormat(this.state.searchModel.assignedDate, `datepicker`)}
                                className="carbondatepicker"
                                light
                            >
                                <DatePickerInput
                                    id="date-picker-input-validUntil"
                                    labelText=""
                                    name="assignedDate"
                                    placeholder="dd/mm/yyyy"
                                    iconDescription="Icon description"

                                    onChange={this.handleChangeDPInput2}
                                />

                            </DatePicker>*/
                <DateTimePicker
                  value={this.state.searchModel.dueDateFrom}
                  type="date"
                  placeholder={DateFormat}
                  name="dueDateFrom"
                  alt="searchModel"
                  // invalid={validations.dueDate != null}
                  onChange={this.updateState}
                  disabled={this.state.isDisabled}
                />
              )}
              {validations.duedate ? (
                <div className="srv-validation-message">
                  {' '}
                  Event date less than the expiration date{' '}
                </div>
              ) : null}
            </FormGroup>
            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel className="some-class">Due Date To</FormLabel>
              {this.state.isLoadingDate ? (
                <DatePickerSkeleton />
              ) : (
                /* <DatePicker
                                id="date-picker-dueDate"
                                datePickerType='single'
                                dateFormat="d/m/Y"
                                onChange={this.handleChangeDP}
                                value={switchDateFormat(this.state.searchModel.dueDate, `datepicker`)}
                                className="carbondatepicker"
                                light
                            >
                                <DatePickerInput
                                    id="date-picker-input-validUntil"
                                    labelText=""
                                    name="dueDate"
                                    placeholder="dd/mm/yyyy"
                                    iconDescription="Icon description"

                                    onChange={this.handleChangeDPInput}
                                />

                            </DatePicker>*/
                <DateTimePicker
                  value={this.state.searchModel.dueDate}
                  type="date"
                  placeholder={DateFormat}
                  name="dueDate"
                  alt="searchModel"
                  // invalid={validations.dueDate != null}
                  onChange={this.updateState}
                  disabled={this.state.isDisabled}
                  invalid={validations.dueDate != null}
                />
              )}
              {validations.dueDate ? (
                <div className="srv-validation-message">
                  {' '}
                  Event date less than the expiration date{' '}
                </div>
              ) : null}
            </FormGroup>
          </Form>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              size="small"
              kind="secondary"
              onClick={this.handleClickCancelSearch}
            >
              Cancel
            </Button>
            <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
              Search
            </Button>
          </div>
        </div>
      )
    );
  }
  taskCompleted = (id) => {
    let entity = this.state.itemList.find((el) => el.id == id);
    if (entity != null && entity.status != 'Completed') {
      return (
        <Link>
          {' '}
          <Button
            size="small"
            renderIcon={CheckmarkOutline16}
            iconDescription="Done"
            kind="ghost"
            onClick={() => this.taskDone(id)}
          />{' '}
        </Link>
      );
    } else return '';
  };
  renderDataTable(headersDataTable) {
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });
    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;
    function getTaskColor(cell) {
      if (cell == null || cell.info == null || cell.value == null) return '';

      if (cell.info.header == 'category' && cell.value == TaskCategory.CATEGORY_APPROVAL)
        return 'approvalC';
      if (cell.info.header == 'category' && cell.value == TaskCategory.CATEGORY_COMPILATION)
        return 'compilationC';

      return '';
    }
    const row = this.state.itemList || [];

    function linkToEntity(id) {
      let entity = row.find((el) => el.id == id);

      if (entity != null && entity.reference != null) {
        return (
          <Link to={entity.reference}>
            <Button
              size="small"
              renderIcon={ChevronRight16}
              iconDescription="Done"
              kind="ghost"
            ></Button>
          </Link>
        );
      } else return '';
    }

    return (
      <div className="some-content">
        <TableToolbar>
          {/* <Search
                                            readOnly
                                            light
                                            className="search cursor-pointer"
                                            labelText="Search"
                                            placeHolderText="Search"
                                            id="search-1"
                                            onClick={this.toggleSearchForm}
                                        />  */}

          <div>
            <Button
              iconDescription="Filter"
              tooltipPosition="top"
              tooltipAlignment="center"
              hasIconOnly
              onClick={this.toggleSearchForm}
              renderIcon={Data16}
            ></Button>
            {/* <Button iconDescription="Download" tooltipPosition="top" tooltipAlignment="center"
                            hasIconOnly onClick={this.showDivDownload} renderIcon={Download16} >

                        </Button>*/}
          </div>
        </TableToolbar>

        {this.state.stateDivDownload ? this.divDownload() : ''}
        {this.renderSearchform()}

        <DataTable
          headers={headersDataTable}
          rows={this.state.itemList || []}
          useZebraStyles={true}
          size="compact"
          render={({ rows, headers, getHeaderProps, getRowProps }) => (
            <TableContainer className="bx--grid--full-width" title="">
              {this.state.isLoading ? (
                <DataTableSkeleton
                  headers={[]}
                  rowCount={skeletonRowCount}
                  zebra={false}
                  compact={false}
                />
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      {headers.map((header) => (
                        <TableHeader
                          className={header.type == 'bool' ? 'align-center' : ''}
                          {...getHeaderProps({ header })}
                        >
                          {header.header}
                        </TableHeader>
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows == null || rows.length == 0 ? (
                      <NoRecordsPlaceholder colSpan={headers.length + 1} />
                    ) : (
                      rows.map((row) => (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map((cell) => (
                            <RenderDataTableCell
                              key={cell.id}
                              cell={cell}
                              header={headers.find((x) => x.key === cell.info.header)}
                              className={getTaskColor(cell)}
                            />
                          ))}

                          <TableCell key={'action-' + row.id} className="tableActions align-center">
                            <div>{linkToEntity(row.id)}</div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          )}
        />
        <div className="footer-pagination">
          <Pagination {...paginationProps()} />
        </div>
      </div>
    );
  }
  render() {
    //     const paginationProps = () => ({
    //         page: this.state.currentPage || 1,
    //         totalItems: this.state.rowCount || 0,
    //         pageSize: this.state.pageSize || 10,
    //         pageSizes: [10, 20, 30, 40, 50],
    //         onChange: this.handleChangePaging,
    //     });
    //     const skeletonRowCount = (this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount) ? this.state.rowCount : this.state.pageSize;
    const headersDataTable = [
      { key: 'category', header: 'Category' },
      { key: 'module', header: 'Module' },
      { key: 'content', header: 'Content' },
      { key: 'status', header: 'Status', type: 'status' },
      { key: 'assignedDate', header: 'Assigned Date', type: 'date' },
      { key: 'dueDate', header: 'DueDate', type: 'date' },
    ];
    const headersDataTable2 = [
      { key: 'module', header: 'Module' },
      { key: 'content', header: 'Content' },
      { key: 'status', header: 'Status', type: 'status' },
      { key: 'assignedDate', header: 'Assigned Date', type: 'date' },
      { key: 'dueDate', header: 'DueDate', type: 'date' },
    ];
    // function getTaskColor(cell) {

    //     if (cell == null || cell.info == null || cell.value == null) return "";

    //     if (cell.info.header == 'category' && cell.value == TaskCategory.CATEGORY_APPROVAL) return "approval";
    //     if (cell.info.header == 'category' && cell.value == TaskCategory.CATEGORY_COMPILATION) return "compilation";
    //  //   if (cell.info.header == 'action') return "";

    //     return "";
    // }
    // const row =this.state.itemList ||[];
    // function linkToEntity(id) {

    //     let entity = row.find(el=>el.id==id);
    //
    //     if (entity != null && entity.reference != null) {
    //         return (<Link to={entity.reference}>
    //             <ArrowR20 />
    //         </Link>);
    //     } else return "";
    // }

    // function taskCompleted(id){
    //     let entity = row.find(el=>el.id==id);
    //     if(entity != null && entity.status != "Completed") {
    //         return  <Button size="small" renderIcon={Checkmark16} iconDescription="Done" kind="ghost" onClick={() => this.taskDone(row)} />
    //     }else return "";
    // }
    return (
      <div className="mainContainer">
        {this.state.spinner ? <Loading></Loading> : ''}
        <h3 className="description-page bx--col-max box--title">All Tasks</h3>
        <div className="bx--grid content">
          <div className=" bx--row ">
            <div className="bx--col  ">
              <div className="bx--row"></div>
              {/* <Tabs selected={0} tabContentClassName="tab-content" className="tab--task--description " > */}
              <Tabs
                onSelectionChange={(index) => this.selectTab(index)}
                className="tab--task--description "
              >
                <Tab key="tab_0" disabled={false} label="All Task" tabIndex={0}>
                  {this.renderDataTable(headersDataTable)}
                  {/* <div className="some-content" >
                                        <TableToolbar>
                                             {/* <Search
                                                readOnly
                                                light
                                                className="search cursor-pointer"
                                                labelText="Search"
                                                placeHolderText="Search"
                                                id="search-1"
                                                onClick={this.toggleSearchForm}
                                            />  */}

                  {/* <div >
                                            <Button iconDescription="Filter" tooltipPosition="top" tooltipAlignment="center"
                                                hasIconOnly onClick={this.toggleSearchForm} renderIcon={Data16}>

                                            </Button>
                                            <Button iconDescription="Download" tooltipPosition="top" tooltipAlignment="center" 
                                                hasIconOnly onClick={this.showDivDownload} renderIcon={Download16} >

                                            </Button>

                                            </div>
                                        </TableToolbar>

                                        {this.state.stateDivDownload ? this.divDownload() : ''}
                                        {this.renderSearchform()}


                                        <DataTable
                                            headers={headersDataTable}
                                            rows={this.state.itemList || []}
                                            useZebraStyles={true}
                                            size="compact"
                                            render={({ rows, headers, getHeaderProps, getRowProps, }) => (
                                                <TableContainer className="bx--grid--full-width" title=""   >
                                                    {this.state.isLoading ?
                                                        <DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
                                                        :
                                                        <Table  >
                                                            <TableHead>
                                                                <TableRow>{headers.map(header => (
                                                                    <TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })} >
                                                                        {header.header}
                                                                    </TableHeader>
                                                                ))}
                                                                    <TableHeader className="align-center">Actions</TableHeader>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    (rows == null || rows.length == 0)
                                                                        ?
                                                                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                                                        :
                                                                        rows.map((row) => (
                                                                            <TableRow {...getRowProps({ row })}>
                                                                                {
                                                                                    row.cells.map(cell =>
                                                                                        <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} className={getTaskColor(cell)} />
                                                                                    )}


                                                                                <TableCell key={'action-' + row.id} className="tableActions align-center">

                                                                                    <div>
                                                                                    {taskCompleted(row.id)}
                                                                                   {linkToEntity(row.id)}

                                                                                      

                                                                                    </div>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                            </TableBody>
                                                        </Table>
                                                    }
                                                </TableContainer>

                                            )}

                                        />
                                        <div className="footer-pagination">
                                            <Pagination {...paginationProps()} />
                                        </div>


                                    </div> */}
                </Tab>

                <Tab key="tab_1" disabled={false} label="Approval" tabIndex={1}>
                  {this.renderDataTable(headersDataTable2)}
                  {/* <div className="some-content" >
                                        <TableToolbar> */}
                  {/* <Search
                                                readOnly
                                                light
                                                className="search cursor-pointer"
                                                labelText="Search"
                                                placeHolderText="Search"
                                                id="search-1"
                                                onClick={this.toggleSearchForm}
                                            /> */}

                  {/* <Button iconDescription="Filter" tooltipPosition="top" tooltipAlignment="center"
                                                hasIconOnly onClick={this.toggleSearchForm} renderIcon={Data16}>

                                            </Button>
                                            <Button iconDescription="Download" tooltipPosition="top" tooltipAlignment="center"
                                                hasIconOnly onClick={this.showDivDownload} renderIcon={Download16} >

                                            </Button> */}

                  {/* </TableToolbar>

                                        {this.state.stateDivDownload ? this.divDownload() : ''}
                                        {this.renderSearchform()}

                                        <DataTable
                                            headers={headersDataTable2}
                                            rows={this.state.itemList || []}
                                            useZebraStyles={true}
                                            size="compact"
                                            render={({ rows, headers, getHeaderProps, getRowProps, }) => (
                                                <TableContainer className="bx--grid--full-width" title=""   >
                                                    {this.state.isLoading ?
                                                        <DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
                                                        :
                                                        <Table  >
                                                            <TableHead>
                                                                <TableRow>{headers.map(header => (
                                                                    <TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })} >
                                                                        {header.header}
                                                                    </TableHeader>
                                                                ))}
                                                                    <TableHeader className="align-center">Actions</TableHeader>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    (rows == null || rows.length == 0)
                                                                        ?
                                                                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                                                        :
                                                                        rows.map((row) => (
                                                                            <TableRow {...getRowProps({ row })}>
                                                                                {
                                                                                    row.cells.map(cell =>
                                                                                        <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} className={getTaskColor(cell)} />
                                                                                    )}


                                                                                <TableCell key={'action-' + row.id} className="tableActions align-center">

                                                                                    <div>
                                                                                        {linkToEntity(row.id)}

                                                                                        {row.cells[2].value != "Completed" ?

                                                                                            <Button size="small" renderIcon={Checkmark16} iconDescription="Done" kind="ghost" onClick={() => this.taskDone(row)} /> : ""} */}

                  {/* </div>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                            </TableBody>
                                                        </Table>
                                                    }
                                                </TableContainer>

                                            )}

                                        />
                                        <div className="footer-pagination">
                                            <Pagination {...paginationProps()} />
                                        </div>


                                    </div> */}
                </Tab>
                <Tab key="tab_2" disabled={false} label="Compilations" tabIndex={2}>
                  {this.renderDataTable(headersDataTable2)}
                  {/* <div className="some-content" >
                                        <TableToolbar> */}
                  {/* <Search
                                                readOnly
                                                light
                                                className="search cursor-pointer"
                                                labelText="Search"
                                                placeHolderText="Search"
                                                id="search-1"
                                                onClick={this.toggleSearchForm}
                                            /> */}

                  {/* <Button iconDescription="Filter" tooltipPosition="top" tooltipAlignment="center"
                                                hasIconOnly onClick={this.toggleSearchForm} renderIcon={Data16}>

                                            </Button>
                                            <Button iconDescription="Download" tooltipPosition="top" tooltipAlignment="center"
                                                hasIconOnly onClick={this.showDivDownload} renderIcon={Download16} >

                                            </Button>


                                        </TableToolbar>

                                        {this.state.stateDivDownload ? this.divDownload() : ''}
                                        {this.renderSearchform()}

                                        <DataTable
                                            headers={headersDataTable2}
                                            rows={this.state.itemList || []}
                                            useZebraStyles={true}
                                            size="compact"
                                            render={({ rows, headers, getHeaderProps, getRowProps, }) => (
                                                <TableContainer className="bx--grid--full-width" title=""   >
                                                    {this.state.isLoading ?
                                                        <DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
                                                        :
                                                        <Table  >
                                                            <TableHead>
                                                                <TableRow>{headers.map(header => (
                                                                    <TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })} >
                                                                        {header.header}
                                                                    </TableHeader>
                                                                ))}
                                                                    <TableHeader className="align-center">Actions</TableHeader>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    (rows == null || rows.length == 0)
                                                                        ?
                                                                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                                                        :
                                                                        rows.map((row) => (
                                                                            <TableRow {...getRowProps({ row })}>
                                                                                {
                                                                                    row.cells.map(cell =>
                                                                                        <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} className={getTaskColor(cell)} />
                                                                                    )}


                                                                                <TableCell key={'action-' + row.id} className="tableActions align-center">

                                                                                    <div>
                                                                                        {linkToEntity(row.id)}
                                                                                        {row.cells[2].value != "Completed" ?

                                                                                            <Button size="small" renderIcon={Checkmark16} iconDescription="Done" kind="ghost" onClick={() => this.taskDone(row)} /> : ""}

                                                                                    </div>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                            </TableBody>
                                                        </Table>
                                                    }
                                                </TableContainer>

                                            )}

                                        />
                                        <div className="footer-pagination">
                                            <Pagination {...paginationProps()} />
                                        </div>


                                    </div> */}
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
